import { registerController } from "../registry";

registerController("color-picker", (el: HTMLElement) => {
  const input = el.querySelector<HTMLInputElement>("[data-color-input]");
  const swatches = el.querySelectorAll<HTMLElement>("[data-color-swatch]");
  const preview = el.querySelector<HTMLElement>("[data-color-preview]");

  if (!input) return;

  function setActive(color: string): void {
    swatches.forEach((s) => {
      const swatchColor = s.dataset.colorSwatch || "";
      if (swatchColor.toLowerCase() === color.toLowerCase()) {
        s.classList.add("is-active");
      } else {
        s.classList.remove("is-active");
      }
    });
    if (preview) {
      preview.style.backgroundColor = color;
    }
  }

  // Set initial active state
  setActive(input.value);

  // Swatch clicks
  swatches.forEach((swatch) => {
    swatch.addEventListener("click", () => {
      const color = swatch.dataset.colorSwatch || "";
      input.value = color;
      setActive(color);
    });
  });

  // Native color input change
  input.addEventListener("input", () => {
    setActive(input.value);
  });
});
